import { kpEndpoint, kpRequest } from '@/axios'

export const SET_PRODUCTS = 'setProducts'
export const SET_BRANDS = 'setBrands'
export const SEARCH_PRODUCTS = 'searchProducts'

const state = {
  products: [],
  brands: [],
}

const mutations = {
  [SET_PRODUCTS](state, products) {
    state.products = products
  },
  [SET_BRANDS](state, brands) {
    state.brands = brands
  },
}

/*
https://pyrepo-api-dev.kingpin.city/docs#/default/products_p_products_search_post
{
  "prompt": "Sport shoes",
  "brand_ids": [
    "string"
  ],
  "gender": [
    "string"
  ],
  "categories": [
    "string"
  ],
  "sub_categories": [
    "string"
  ]
}
 */
const actions = {
  async [SEARCH_PRODUCTS](ctx, { params }) {
    if (!params || typeof params !== 'object') {
      console.error('Invalid search parameters provided')
      return
    }
    try {
      const productSearchRes = await kpRequest({
        ...kpEndpoint.product.search,
        payload: params,
      })

      const responseData = productSearchRes?.data || { products: [], brands: [] }

      ctx.commit(SET_PRODUCTS, responseData.products || [])
      ctx.commit(SET_BRANDS, responseData.brands || [])

      return responseData
    } catch (err) {
      console.error('Product search failed:', err)
      ctx.commit(SET_PRODUCTS, [])
      ctx.commit(SET_BRANDS, [])
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
